module.exports = __webpack_public_path__ + "static/valeriia-513bb7836479909af4c1c4c3913e4db3.png";